module.exports = __webpack_public_path__ + "static/media/last-page-success.abbae6ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/last-page-success.svg
// module id = 1386
// module chunks = 0